import type { ThirdPartyFeedbackProvider } from 'api/integrationsConfig'
import imgBlackBoxIntelligence from 'assets/images/integrations/app-icons/img_black_box_intelligence.png'
import imgOvation from 'assets/images/integrations/app-icons/img_ovation.png'
import imgTattle from 'assets/images/integrations/app-icons/img_tattle.png'
import imgYumpingo from 'assets/images/integrations/app-icons/img_yumpingo.png'

// Square app icons for the third-party feedback tools this page can name,
// keyed the way `scenes/PromoCodes/Overview/providerLogos` keys its wordmarks.
//
// context:
//   These are the tools' APP icons, not the wide wordmarks in
//   `integrations/logos/` — the design sets this one in a 42px rounded tile,
//   and those are 61x24 to 124x25, so they cannot fill it. GuestXM and Momos
//   have only wordmarks today, so the caller drops the tile for them until
//   design supplies app icons.
//
//   Black Box Intelligence's is the brand's full lockup — hexagon above the
//   words, on white — rather than a mark-only tile like the other three. It is
//   legible as a shape at 42px but its wordmark is not, which is a question
//   for design rather than something to fix by cropping a partner's logo here.
const PROVIDER_APP_ICONS: Partial<Record<ThirdPartyFeedbackProvider, string>> =
  {
    black_box_intelligence: imgBlackBoxIntelligence,
    ovation: imgOvation,
    tattle: imgTattle,
    yumpingo: imgYumpingo,
  }

export const providerAppIcon = (
  provider: ThirdPartyFeedbackProvider | null | undefined
): string | null => (provider ? PROVIDER_APP_ICONS[provider] ?? null : null)
